export function transformDate(initialDate: string) {
  const currentDate = new Date(initialDate);

  const time = currentDate.toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true }).toLowerCase();

  const date = currentDate.toLocaleString("en-US", { day: "numeric", month: "numeric", year: "2-digit" });

  return `${time} ${date}`;
}
